import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20 4H4a1 1 0 00-1 1v3a1 1 0 102 0V6h6v13H9a1 1 0 000 2h6a1 1 0 000-2h-2V6h6v2a1 1 0 002 0V5a1 1 0 00-1-1z",
			fillRule: "nonzero"
		})
	})
});
export { SvgText as ReactComponent };
